<template>
    <div id="change-password" class="root">
        <div class="row">
            <div class="col-lg-12 content-title mt-1 mb-3">
                <h2 class="content-title">Jelszóváltoztatás</h2>
            </div>
        </div>
        <div class="row justify-content-center">
            <loader :loading="loading_status"></loader>
        </div>
        <div class="row">
            <div class="col-lg-12 content-body">
                <div class="user-info">
                    <div class="row form-group">
                        <div class="col-sm-3">
                            <label class="control-label">Új jelszó</label>
                            <input type="password" class="form-control" v-model="my_account.password" autocomplete="off"
                                   :class="{ 'field-error' : this.$v.my_account.password.$error }"/>
                        </div>
                        <div class="col-sm-3">
                            <label class="control-label">Új jelszó megerősítése</label>
                            <input type="password" class="form-control" v-model="my_account.confirm_password" autocomplete="off"
                                   :class="{ 'field-error' : this.$v.my_account.confirm_password.$error }"/>
                        </div>
                        <div class="col-sm-3 pt-4">
                            <button class="btn btn-md btn-primary" @click="save">Mentés</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loader from '../common/controls/Loader'
    import { mapGetters, mapActions } from 'vuex'
    import requiredIf from "vuelidate/src/validators/requiredIf";
    import required from "vuelidate/src/validators/required";

    export default{
        name: 'ChangePassword',
        data(){
            return{

            }
        },
        components: {
            Loader
        },
        computed: {
            ...mapGetters([
                'user',
                'loading',
                'appSettings',
                'stores',
            ]),
            loading_status: {
                get: function() {
                    return this.loading ? this.loading : false;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
            my_account: {
                get: function() {
                    return this.user;
                },
                set: function(newVal) {
                    return newVal;
                }
            },
        },
        methods: {
            ...mapActions([
                'updatePassword',
            ]),
            save() {
                this.$v.my_account.$touch();

                if(!this.$v.my_account.$invalid) {
                    this.updatePassword({
                        id: this.user.id,
                        password: this.my_account.password,
                    }).then((response) => {
                        this.my_account.password = '';
                        this.my_account.confirm_password = '';
                    });
                } else {
                    this.$store.commit('setErrorMessage', 'Töltse ki a megjelölt mezőket!');
                }
            },
        },
        mounted(){

        },
        watch: {
            user: {
                handler: function(newVal) {
                    this.my_account = newVal;
                },
                deep: true,
            }
        },
        validations() {
            let vm = this;

            return {
                my_account: {
                    password: {
                        required,
                    },
                    confirm_password: {
                        required: requiredIf(function () {
                            return vm.my_account.password;
                        }),
                    },
                }
            }
        },
    }
</script>

<style scoped="">

</style>
